import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSTagsCollection = GenericCollectionFactory("PMS_TAGS", "tag")